<script setup>
import { computed } from 'vue';
import { useAccount } from 'dashboard/composables/useAccount';
import { useI18n } from 'vue-i18n';
import SettingRow from 'dashboard/components-next/polaris/cards/SettingRow.vue';

import SectionLayout from './SectionLayout.vue';

const { t } = useI18n();
const { currentAccount } = useAccount();

// Phase 9.4: a read-only field with "Copy" (the kit's SettingRow), in place of the code block.
const row = computed(() => ({
  id: 'account-id',
  kind: 'readonly',
  label: t('GENERAL_SETTINGS.FORM.ACCOUNT_ID.TITLE'),
  value: currentAccount.value?.id?.toString() ?? '',
}));
</script>

<template>
  <SectionLayout
    :title="t('GENERAL_SETTINGS.FORM.ACCOUNT_ID.TITLE')"
    :description="t('GENERAL_SETTINGS.FORM.ACCOUNT_ID.NOTE')"
  >
    <SettingRow :row="row" />
  </SectionLayout>
</template>
